import AppSelectionPage from './AppSelectionPage';

export default AppSelectionPage;
